import { IBranch } from '~/types/branches';

export const checkBranchesPosConflict = (branch: IBranch | undefined, selectedBranches: Partial<IBranch>[]): boolean => {
  const posServiceEnabled = Boolean(branch?.pos_service_id);

  if (!selectedBranches.length) {
    return !posServiceEnabled;
  }

  const hasPosServiceBranch = selectedBranches.some((branch) => Boolean(branch.pos_service_id));
  const isValidBranch = posServiceEnabled ? hasPosServiceBranch : !hasPosServiceBranch;

  return isValidBranch;
};

export const getBranchesWithoutPosConflict = (branches: IBranch[], selectedBranches: Partial<IBranch>[]): IBranch[] => {
  const hasPosServiceId = (branch: IBranch) => !!branch.pos_service_id;

  if (selectedBranches.length === 0) {
    const allBranchesHavePosServiceId = branches.every(hasPosServiceId);
    return allBranchesHavePosServiceId ? branches : branches.filter((branch) => !hasPosServiceId(branch));
  }

  return branches.filter((branch) => checkBranchesPosConflict(branch, selectedBranches) ?? true);
};
